<template>
    <div class="apprentice-simple-card messages">
        <design-2021-apprentice-message-history-component
            v-if="messages.length"
            :messages-in="messages"
            :message-type="messageType"
            :widget-mode="widgetMode"
            @remove-project-message="removeProjectMessage"
            @remove-group-message="removeGroupMessage"
            @update-project-message="updateProjectMessage"
            @update-group-message="updateGroupMessage">
        </design-2021-apprentice-message-history-component>

        <div
            class="empty-message-list"
            v-else>
            <b-alert
                show
                variant="info"
                >{{ $t('project.no_messages_post_yet') }}</b-alert
            >
        </div>

        <design-2021-group-show-edit-message-modal-component
            ref="edit-message-modal"
            @update-message="onUpdate($event)"></design-2021-group-show-edit-message-modal-component>
        <div
            class="compose-message"
            v-if="canRespond">
            <b-form-group
                class="subject-group"
                :label="$t('project.subject')"
                label-for="message-subject">
                <b-form-input
                    class="message-subject"
                    id="message-subject"
                    v-model="subject"></b-form-input>
            </b-form-group>
            <ckeditor
                v-model="newMessage"
                :editor="editor"
                :config="editorConfig"
                :placeholder="$t('project.new_message')">
            </ckeditor>

            <div
                class="visibility-option"
                v-if="advancedOption">
                <b-form-group :label="$t('project.visible')">
                    <b-form-radio-group
                        v-model="selected"
                        clas="apprentice-radiobutton visibility-option-radio-group"
                        :options="options">
                    </b-form-radio-group>
                </b-form-group>
            </div>

            <b-button
                class="btn-message btn-message-send"
                variant="primary"
                @click="addMessage"
                :disabled="!newMessage">
                {{ $t('project.send_message') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-project-show-message-component',
    props: {
        projectTypeId: Number,
        messagesIn: Array,
        messageType: String,
        isStudent: Boolean,
        profileImageIn: Object,
        widgetMode: {
            type: Boolean,
            default: false,
        },
        canRespond: {
            type: Boolean,
            default: true,
        },
        advancedOption: {
            type: Boolean,
            required: false,
            default: () => false,
        },
    },
    data() {
        return {
            messages: this.messagesIn,
            subject: '',
            newMessage: '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            selected: 1,
            options: [
                { text: this.$t('project.everyone'), value: 1 },
                { text: this.$t('project.only_teachers'), value: 2 },
            ],
        };
    },
    methods: {
        displayDateTime(dateTime) {
            if (dateTime) {
                return (
                    moment(new Date(dateTime)).format('D-MM-YYYY') + ' om ' + moment(new Date(dateTime)).format('H:mm')
                );
            }
            return null;
        },

        canEdit(message) {
            if (this.messageType === 'project') {
                if (
                    message.user_id === this.$authUser.id &&
                    !this.isStudent &&
                    message.model_type === 'App\\Models\\Project'
                ) {
                    return true;
                }
            } else if (this.messageType === 'group') {
                if (message.model_type == 'App\\Models\\Group') {
                    if (message.user_id === this.$authUser.id && !this.isStudent) {
                        return true;
                    }
                }
            }

            return false;
        },

        addMessage() {
            this.alert.saving();

            const newMessage = {
                subject: this.subject,
                message: this.newMessage,
                type: this.messageType, // todo er af
                message_type: this.selected,
            };

            if (this.messageType === 'project') {
                this.addNewProjectMessage(newMessage);
            } else if (this.messageType === 'group') {
                this.addNewGroupMessage(newMessage);
            }

            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },

        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('project.delete_message'),
                    this.$t('project.are_you_sure_you_want_to_delete_this_message'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        if (this.messageType === 'project') {
                            this.removeProjectMessage(id);
                        } else if (this.messageType === 'group') {
                            this.removeGroupMessage(id);
                        }
                    }
                });
        },

        onEdit(message) {
            this.$refs['edit-message-modal'].show(message);
        },

        onUpdate(messageContent) {
            this.alert.saving();

            const updateMessage = {
                id: messageContent.id,
                subject: messageContent.subject,
                message: messageContent.message,
                type: this.messageType,
            };

            if (this.messageType === 'project') {
                this.updateProjectMessage(updateMessage);
            } else if (this.messageType === 'group') {
                this.updateGroupMessage(updateMessage);
            }
        },

        addNewProjectMessage(newMessage) {
            this.axios.post(this.routes.projectMessageCreate(this.projectTypeId), newMessage).then(
                (response) => {
                    this.messages.push(response.data);
                    this.newMessage = '';
                    this.subject = '';
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        addNewGroupMessage(newMessage) {
            this.axios.post(this.routes.groupMessageCreate(this.projectTypeId), newMessage).then(
                (response) => {
                    this.messages.push(response.data);
                    this.subject = '';
                    this.newMessage = '';
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeProjectMessage(id) {
            this.axios.delete(this.routes.projectMessageRemove(this.projectTypeId, id)).then(
                (response) => {
                    this.messages = this.messages.filter((item) => item.id !== id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeGroupMessage(id) {
            this.axios.delete(this.routes.groupMessageRemove(this.projectTypeId, id)).then(
                (response) => {
                    this.messages = this.messages.filter((item) => item.id !== id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateProjectMessage(updatedMessage) {
            this.axios.post(this.routes.projectMessageUpdate(this.projectTypeId), updatedMessage).then(
                (response) => {
                    this.messages = this.messages.map((item) => (item.id === updatedMessage.id ? response.data : item));
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateGroupMessage(updatedMessage) {
            this.axios.post(this.routes.groupMessageUpdate(this.projectTypeId), updatedMessage).then(
                (response) => {
                    this.messages = this.messages.map((item) => (item.id === updatedMessage.id ? response.data : item));
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        scrollToBottom() {
            if (this.$refs.messageListContainer) {
                // ToDo: Nice to have scroll to top latest message
                this.$refs.messageListContainer.scrollTop =
                    this.$refs.messageListContainer.scrollHeight - this.$refs.messageListContainer.clientHeight;
            }
        },

        wordCount(message, limit) {
            return message.split(' ').length > limit;
        },

        getMessagePart(message, firstPart, limit) {
            let rawMessage = message;
            if (firstPart) {
                return rawMessage.split(' ').splice(0, limit).join(' ') + ' ...';
            }
            return rawMessage.split(' ').splice(limit).join(' ');
        },

        getProfileImage(message) {
            if (message.user.profileimage) {
                return message.user.profileimage.file.public_path;
            } else if (this.profileImageIn && this.profileImageIn.file) {
                return this.profileImageIn.file.public_path;
            }

            return '/images/default_avatar_profile.jpg';
        },
    },
    mounted() {
        let params = new URL(document.location).searchParams;

        if (params.get('message')) {
            this.scrollToBottom();
        }

        this.$nextTick(() => {
            this.scrollToBottom();
        });
    },

    updated() {
        this.scrollToBottom();
    },
};
</script>

<style scoped lang="scss">
.message-item {
    &:hover {
        .user-info {
            .credentials,
            .date {
                font-weight: $font-weight-bold;
            }

            .message-maintenance {
                opacity: 1;
            }
        }
    }
}

.user-info {
    position: relative;

    .message-maintenance {
        position: absolute;
        right: 0;
        display: flex;
        align-content: center;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        z-index: 5;

        .btn {
            font-size: $default-font-size;

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }
    }
}

.compose-message {
    margin-top: $grid-gutter-width;

    .visibility-option {
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.btn-message-send {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.visibility-option ::v-deep {
    label.custom-control-label {
        span {
            line-height: 1.7;
        }
    }
}
</style>
